export default __webpack_public_path__ + "static/media/foto5.08534632.jpg";